import Collapse from "bootstrap/js/dist/collapse";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { isFunction } from "utils/helpers";
import LocaleLink from "views/components/LocaleLink";

const Err = ({ code, codeMessage, message, onReset }) => {
	const { t } = useTranslation();

	// ref hook
	const collapseRef = useRef(null);

	// state hooks
	const [isCollapseOpen, setIsCollapseOpen] = useState(false);

	// effect hooks
	useEffect(() => {
		const collapseRefCurrent = collapseRef?.current;
		let collapse = Collapse.getInstance(collapseRefCurrent);

		if (isFunction(onReset)) {
			if (!collapse) {
				collapse = new Collapse(collapseRefCurrent, { toggle: false })[isCollapseOpen ? "show" : "hide"]();
			} else {
				if (isCollapseOpen) collapse.show();
				if (!isCollapseOpen) collapse.hide();
			}
		}

		return () => (collapse && isFunction(onReset) ? Collapse.getInstance(collapseRefCurrent).dispose() : false);
	}, [isCollapseOpen, onReset]);

	return (
		<section className="py-5">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-10 col-sm-8 col-md-7 col-lg-5 col-xl-4">
						<div className="card border-0 text-center">
							<div className="card-body border-0">
								<div className="row gy-4">
									<div className="col-12">
										<h1 className="text-uppercase fw-normal mb-0">
											<span className="d-block text-primary display-1 fw-bolder">{code}</span>
											<span className="d-block fs-5 fw-normal mt-n2">{codeMessage}</span>
										</h1>
									</div>
									{isFunction(onReset) ? (
										<div
											id="showMoreCollapse"
											className={`col-12 collapse ${isCollapseOpen ? "show" : ""}`}
											ref={collapseRef}>
											<p className="mb-0">
												<small>{message}</small>
											</p>
										</div>
									) : (
										<div className="col-12">
											<p className="mb-0 text-uppercase fw-light fs-3">{message}</p>
										</div>
									)}
									<div className="col-12">
										{isFunction(onReset) ? (
											<div className="row gy-2 mt-0">
												<div className="col-12 mt-0">
													<button
														className="btn btn-link w-100 text-uppercase p-2"
														type="button"
														data-bs-target="#showMoreCollapse"
														aria-expanded={isCollapseOpen}
														aria-controls="showMoreCollapse"
														tabIndex="-1"
														onClick={() =>
															setIsCollapseOpen((prevState) => !prevState || false)
														}>
														<small>{`show ${isCollapseOpen ? "less" : "more"} info`}</small>
													</button>
												</div>
												<div className="col-12">
													<button
														className="btn btn-primary w-100 text-uppercase p-2"
														onClick={onReset}>
														<small>refresh</small>
													</button>
												</div>
											</div>
										) : (
											<LocaleLink to="/" className="btn btn-primary w-100 text-uppercase">
												{t("actions.go_back")}
											</LocaleLink>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Err;
